// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redaktor-login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.redaktor-login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  border: 1px solid #E5E5E5;
}

.redaktor-login-header {
  text-align: center;
  margin-bottom: 30px;
}

.redaktor-login-header h1 {
  color: #7B2323;
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  letter-spacing: 1px;
}

.redaktor-login-header p {
  color: #5D3A3A;
  font-size: 1rem;
  margin: 0;
  font-weight: 300;
  opacity: 0.8;
}

.redaktor-login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: #3D1818;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input {
  padding: 12px 16px;
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #FAFAFA;
}

.form-group input:focus {
  outline: none;
  border-color: #D4A574;
  background: white;
  box-shadow: 0 0 0 3px rgba(212, 165, 116, 0.1);
}

.form-group input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid #DC3545;
  border-radius: 6px;
  padding: 12px;
  color: #721C24;
  font-size: 0.9rem;
  text-align: center;
}

.login-button {
  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);
  color: white;
  border: none;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 10px;
}

.login-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #6B1F1F 0%, #2D1414 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 35, 35, 0.3);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

/* Responsive design */
@media (max-width: 480px) {
  .redaktor-login-container {
    padding: 15px;
  }
  
  .redaktor-login-card {
    padding: 30px 25px;
  }
  
  .redaktor-login-header h1 {
    font-size: 1.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RedaktorLogin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".redaktor-login-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.redaktor-login-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid #E5E5E5;\n}\n\n.redaktor-login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.redaktor-login-header h1 {\n  color: #7B2323;\n  font-family: 'Playfair Display', serif;\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  letter-spacing: 1px;\n}\n\n.redaktor-login-header p {\n  color: #5D3A3A;\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 300;\n  opacity: 0.8;\n}\n\n.redaktor-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  color: #3D1818;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 2px solid #E5E5E5;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: #FAFAFA;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #D4A574;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(212, 165, 116, 0.1);\n}\n\n.form-group input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid #DC3545;\n  border-radius: 6px;\n  padding: 12px;\n  color: #721C24;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #7B2323 0%, #3D1818 100%);\n  color: white;\n  border: none;\n  padding: 14px 20px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 10px;\n}\n\n.login-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #6B1F1F 0%, #2D1414 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(123, 35, 35, 0.3);\n}\n\n.login-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n/* Responsive design */\n@media (max-width: 480px) {\n  .redaktor-login-container {\n    padding: 15px;\n  }\n  \n  .redaktor-login-card {\n    padding: 30px 25px;\n  }\n  \n  .redaktor-login-header h1 {\n    font-size: 1.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
